"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeAttachmentsClient = void 0;
class FakeAttachmentsClient {
    constructor() {
        this.attachmentTypes = [];
    }
    insertAttachmentType(attachmentType) {
        this.attachmentTypes.push(attachmentType);
    }
    getTypes() {
        return Promise.resolve(this.attachmentTypes);
    }
    clear() {
        this.attachmentTypes = [];
    }
}
exports.FakeAttachmentsClient = FakeAttachmentsClient;
//# sourceMappingURL=FakeAttachmentsClient.js.map